module.exports = __webpack_public_path__ + "static/media/programa_campo_esquema.5e3aa375.jpg";